var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron_backward",
    d: "M15 18.2929L8.70711 12L15 5.70711L15.1201 5.8272L9.30808 11.6392L8.95452 11.9928L9.30808 12.3463L15.1273 18.1656L15 18.2929Z",
    fill: "#141414",
    stroke: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbutton);
export default __webpack_public_path__ + "static/media/backbutton.d3c5cf47afd4c15c22e04b1b48e6fe26.svg";
export { ForwardRef as ReactComponent };